import { render, staticRenderFns } from "./OrganisationAssigner.vue?vue&type=template&id=370328fc&scoped=true&"
import script from "./OrganisationAssigner.vue?vue&type=script&lang=js&"
export * from "./OrganisationAssigner.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationAssigner.vue?vue&type=style&index=0&id=370328fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370328fc",
  null
  
)

export default component.exports